export enum EIndicator {
  PREMIUM_PER_PRODUCT = 'premium_per_product',
  PREMIUM_PER_OZ = 'premium_per_oz',
  PREMIUM_PER_GRAM = 'premium_per_gram',
  COLLECTIBLE = 'collectible',
}
